export const sponsors = [

    {
        id: "truethai-mel",
        label: "True Thai Massage",
        href: "https://truethai.com.au",
        imageSrc: "/images/sponsors/TrueThai/Ad-TTM.png",
        country: "Australia", 
        city: "Melbourne",
    },
    {
        id: "cabinetbar-mel",
        label: "Cabinet Bar",
        href: "https://cabinetbar.com.au",
        imageSrc: "/images/sponsors/CabinetBar/Ad-Cabinet.png",
        country: "Australia", 
        city: "Melbourne",
    },
];
